import { useLayoutEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

const RouteScrollManager = (): null => {
  const location = useLocation();
  const navigationType = useNavigationType();

  useLayoutEffect(() => {
    if (navigationType !== 'POP' && !location.hash) {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }
  }, [location.key, location.hash, navigationType]);

  return null;
};

export default RouteScrollManager;
